import { render, staticRenderFns } from "./SelectTreeCategory.vue?vue&type=template&id=25d2ac63"
import script from "./SelectTreeCategory.vue?vue&type=script&lang=js"
export * from "./SelectTreeCategory.vue?vue&type=script&lang=js"
import style0 from "./SelectTreeCategory.vue?vue&type=style&index=0&id=25d2ac63&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports